import { Icon } from '@iconify/react';
import React from 'react';

const RecentActivityAnalytics = () => {
  const recentActivities = [
    {
      title: "Bulk Campaign Sent",
      time: "10 minutes ago",
      description: "Summer promotion campaign delivered to 5,230 contacts",
    },
    {
      title: "New Contacts Added",
      time: "1 hour ago",
      description: "1,250 new contacts were imported from CSV",
    },
    {
      title: "New Template Approved",
      time: "3 hours ago",
      description: "Your 'Customer Feedback' template was approved",
    },
    {
      title: "High Bounce Rate Detected",
      time: "Yesterday",
      description: "Your last campaign had a 5% bounce rate",
    },
  ];

  return (
    <div className="col-md-8">
      <div className="card h-100">
        <div className="card-body p-24">
          <div className="d-flex align-items-center gap-2 mb-4">
            <div>
              <h6 className="mb-2 text-lg">Recent Activity</h6>
              <p>Your latest messaging activities</p>
            </div>
          </div>

          {recentActivities.map((activity, index) => (
            <div key={index} className="d-flex align-items-center gap-2 mb-3">
              <div className="w-40-px h-40-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                <Icon icon="mdi:account-box" className="text-white text-2xl mb-0" />
              </div>
              <div className="w-100">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="mb-2 fw-bold text-sm">{activity.title}</p>
                  <p className="mb-2 text-sm">{activity.time}</p>
                </div>
                <p className="text-sm pb-0">{activity.description}</p>
              </div>
            </div>
          ))}
          
        </div>
      </div>
    </div>
  );
};

export default RecentActivityAnalytics;
